import userApi from "./userApi";
import Swal from "sweetalert2";
interface Servise {
	id: number;
	comment: string;
}

(() => {
	(<any>window).Swal = Swal;

	let isInit = false;
	document.addEventListener("DOMContentLoaded", () => {
		init();
	});
	setInterval(() => {
		if (!isInit) {
			if (document.readyState === "complete") {
				init();
			}
		}
	}, 400);

	// user
	// localStorage.user = "";

	//
	// cookies
	const init = () => {
		console.log("main DOMContentLoaded init");
		//@ts-ignore
		if (isInit === true) return false;
		//@ts-ignore
		isInit = true;
		(() => {
			const jsCookies = document.querySelector<HTMLElement>(`.jsCookies`);
			const cookies = localStorage.getItem("cookies");
			if (jsCookies) {
				jsCookies.onclick = () => {
					localStorage.setItem("cookies", JSON.stringify(true));
					jsCookies.classList.remove("isOpen");
				};
				if (!cookies) {
					setTimeout(() => {
						jsCookies.classList.add("isOpen");
					}, 4000);
				}
			}
		})();
		// END cookies
		//order fix
		if (location.pathname === "/order") {
			const orderUrl = localStorage.getItem("orderUrl");
			if (orderUrl) {
				location.pathname = "/order/" + orderUrl;
			}
		}

		// utils
		const jsLoader = document.querySelector<HTMLElement>(`.jsLoader`);

		const formToObject = (form: HTMLFormElement) => {
			// const form = document.querySelector('form');
			const formData = new FormData(form);
			let data: any = {};
			for (var [key, value] of formData.entries()) {
				data[key] = value;
			}
			return data;
		};
		(<any>window).formToObject = formToObject;
		//

		// END utils
		const header = <HTMLElement>document.querySelector(`header`);
		document.addEventListener("scroll", (event) => {
			if (document.documentElement.scrollTop > 100) {
				if (!header.classList.contains(`is-small`)) {
					header.classList.add(`is-small`);
				}
			} else {
				if (document.documentElement.scrollTop < 50) {
					if (header.classList.contains(`is-small`)) {
						header.classList.remove(`is-small`);
					}
				}
			}
		});
		const jsAnnotation =
			document.querySelectorAll<HTMLElement>(`.jsAnnotation`);
		if (jsAnnotation) {
			jsAnnotation.forEach((item) => {
				let text = item.innerText.replace(
					"(",
					"<span class='annotation'>"
				);
				text = text.replace(")", "</span>");
				item.innerHTML = text;
			});
		}
		// <HTMLElement>

		// orderUpdate
		const urlParams = new URLSearchParams(window.location.search);

		if (urlParams.get("isOrderUpdate") === "true") {
			// let formData = (<any>window).formToObject(jsProduct);
			const jsProduct = document.querySelector<HTMLElement>(`.jsProduct`);
			if (jsProduct) {
				const productId = parseInt(jsProduct.dataset.id + "");
				jsProduct.classList.add(`isOrderUpdate`);
				const orderUpdateData = {
					orderId: parseInt(urlParams.get("order") + ""),
					productId: productId,
				};
				localStorage.setItem(
					"orderUpdateData",
					JSON.stringify(orderUpdateData)
				);
			}
			// const jsShowbyOneClickForm = document.querySelector<
			// 	HTMLElement
			// >(`.jsShowbyOneClickForm`);
			// if (jsShowbyOneClickForm) {
			// 	jsShowbyOneClickForm.style.display = "none";
			// }
			// const jsAddToCart = document.querySelector<HTMLElement>(
			// 	`.jsAddToCart`
			// );
			// if (jsAddToCart) {
			// 	jsAddToCart.style.display = "none";
			// }
			// const jsUpdateOrder = document.querySelector<HTMLElement>(
			// 	`.jsUpdateOrder`
			// );
			// if (jsUpdateOrder) {
			// 	// jsUpdateOrder.style.display = "flex";
			// 	const jsProduct = document.querySelector<HTMLElement>(
			// 		`.jsProduct`
			// 	);

			// 	if (jsProduct) {

			// 		jsUpdateOrder.addEventListener("click", () => {
			// 			// let formData = (<any>window).formToObject(jsProduct);
			// 			const productId = parseInt(jsProduct.dataset.id + "");
			// 			const data = {
			// 				orderId: parseInt(urlParams.get("order") + ""),
			// 				productId: productId,
			// 				services: (<any>window).getProductData(productId).services
			// 			};
			// 			fetch(`/ajax-api/update_order.php`, {
			// 				method: "post",
			// 				body: JSON.stringify(data)
			// 			})
			// 				.then(res => res.json())
			// 				.then(res => {
			// 					console.log(res);
			// 				});
			// 		});// jsUpdateOrder click
			// 	} //if (jsProduct)
			// }
			//
		}
		// END orderUpdate

		if ((<any>window).mdc) {
			(<any>window).mdc.autoInit();
		}

		const jsCloseSearch = <HTMLElement>(
			document.querySelector(`.jsCloseSearch`)
		);
		const jsSearch = <HTMLElement>document.querySelector(`.jsSearch`);
		// const jsSearchInput = <HTMLInputElement>document.querySelector(`.jsSearchInput`);

		if (jsCloseSearch && jsSearch) {
			jsCloseSearch.addEventListener("click", () => {
				if (location.search.includes("keyword")) {
					location.search = "";
				}
				jsSearch.classList.toggle("is-open");
			});
		}
	};
})();
